import { useEffect, useRef } from "react";

// The latest value in a ref, for reading it after an await without re-running the effect.
export function useLatest<T>(value: T) {
  const ref = useRef(value);
  useEffect(() => { ref.current = value; }, [value]);
  return ref;
}
